import { NgModule } from '@angular/core';
import {  MatChipsModule } from '@angular/material/chips';
import {  MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {  MatFormFieldModule } from '@angular/material/form-field';
import {  MatInputModule } from '@angular/material/input';
import {  MatButtonModule } from '@angular/material/button';
import { FilterByPipeModule } from '../../../pipes/filter-by';
import { ChipsSelectorFormFieldComponent } from './chips-selector-form-field.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { IsSelectAllShowPipe } from './is-select-all-show.pipe';
import { ChipsSelectorOptionClassesPipe } from './chips-selector-option-classes.pipe';
import { DisableAutocompleteDirectiveModule, TooltipIfTruncatedModule } from 'src/app/shared/directives';
import { CdkConnectedOverlay, OverlayModule } from '@angular/cdk/overlay';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [ChipsSelectorFormFieldComponent, IsSelectAllShowPipe, ChipsSelectorOptionClassesPipe],
	imports: [
		DisableAutocompleteDirectiveModule,
		TooltipIfTruncatedModule,
		MatChipsModule,
		MatAutocompleteModule,
		CommonModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		FilterByPipeModule,
		MatButtonModule,
		ScrollingModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		OverlayModule,
		CdkConnectedOverlay,
		FontAwesomeModule,
	],
    exports: [ChipsSelectorFormFieldComponent]
})
export class ChipsSelectorFormFieldModule {}
